// To be kept in sync with https://git.hubteam.com/HubSpot/IdentityBase/blob/4ca4df7afe02596f75d07922ff1b6f9d2c41d38b/src/main/protobuf/properties.proto#L130
// (link is to commit as of 1/14/2021, check file at latest master for updates)

const OptionSortStrategy = {
  DISPLAY_ORDER: 'DISPLAY_ORDER',
  ALPHABETICAL: 'ALPHABETICAL'
};
export default OptionSortStrategy;